import script from "./setPwd.vue?vue&type=script&setup=true&name=SetPwd&lang=js"
export * from "./setPwd.vue?vue&type=script&setup=true&name=SetPwd&lang=js"

import "./setPwd.vue?vue&type=style&index=0&id=83304b42&scoped=true&lang=css"
import "./setPwd.vue?vue&type=style&index=1&id=83304b42&lang=css"

import exportComponent from "/Users/nasinet/hujing_pro/hj_pro_h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83304b42"]])

export default __exports__